export default "__VITE_ASSET__DsYDY$_e__"